import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

interface EditMarginModalProps {
  status: boolean;
  close: () => void;
  accept: () => void;
}

export const DeletePackagingMarginModal = ({
  status,
  close,
  accept,
}: EditMarginModalProps) => {
  return (
    <Dialog open={status} onClose={close}>
      <DialogTitle id="alert-dialog-title">
        Delete packaging margins
      </DialogTitle>
      <DialogContent>
        Are you sure you want to delete packaging margins?
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button color="primary" onClick={accept} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
